import cardsIcons from './cardsIcons';

export default function () {
  const widgetName = 'cardWithIcons';
  const widgetOpts = cardWithIconsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;

      if (widgetData.length <= 0) {
        $('body').addClass(`${widgetName}-no-data`);
        $(`${widgetName}`).remove();
        return;
      } else {
        createCustomCards(widgetData);
        cardsIcons();
      }
      function createCustomCards(widgetData) {
        $(`#${widgetName} .card-widget-item`).each(function (x) {
          $(this).empty();
          const cardStructure = `
          <div class="img-container">
            <img class="img-background lozad" src='${widgetData[x].ImageWithPath}' alt="${widgetData[x].Title}"/> 
            <div class=" overlay"></div>
          </div>
          <span class="widget-title"><h2>${widgetData[x].Title}</h2></span>
          `;

          $(this).append(cardStructure);

          if (widgetData[x].URL == null) {
            $(this).removeAttr('href');
          } else {
            $(this).removeAttr('target');
          }
        });
      }
    },
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    link: ['all'],
    itemsPerPanel: 1,
    maxItemsVisible: 8,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    scriptPath: widgetOpts.scriptPath,
  });
}
